import styled from '@emotion/styled';

type Props = {
  className?: string;
} & ChildrenProps;

export function Container({ className, children }: Props) {
  return (
    <Root className={className}>
      {children}
    </Root>
  );
}

const Root = styled.div`
  box-sizing: border-box;
  margin: 20px 0;

  > *:not(:last-child) {
    margin-bottom: 20px;  
  }
`;